export default {
  state: {
    BigPreloader: false,
    TypeProject: null,
    MinimizeSidebar: false,
    ActiveProject: 0,
    SettingsVisible: false,
    WarningModal: false,
    WarningData: {},
    SelectedRowTableId: 0
  },
  getters: {
    getBigPreloader: state => state.BigPreloader,
    getTypeProject: state => state.TypeProject,
    getMinimizeSidebar: state => state.MinimizeSidebar,
    getActiveProject: state => state.ActiveProject,
    getSettingsVisible: state => state.SettingsVisible,
    getWarningModal: state => state.WarningModal,
    getWarningData: state => state.WarningData,
    getSelectedRowTableId: state => state.SelectedRowTableId
  },
  mutations: {
    SetBigPreloader (state, val) {
      state.BigPreloader = val
    },

    SetMinimizeSidebar (state, val) {
      state.MinimizeSidebar = val
    },

    SetActiveProject (state, val) {
      state.ActiveProject = val
    },

    SetSettingsVisible (state, val) {
      state.SettingsVisible = val
    },

    SetWarningModal (state, val) {
      state.WarningModal = val
    },

    SetWarningData (state, val) {
      state.WarningData = val
    },
    SetSelectedRowTableId (state, val) {
      state.SelectedRowTableId = val
    }
  },
  actions: {
    setShowErrorModal ({ commit }, resp) {
      commit(
        'SetWarningData',
        {
          style: resp.DialogStyle,
          description: resp.Description,
          message: resp.Message
        }
      )
      commit('SetWarningModal', true)
    }
  }
}
